const editMandatoryFieldsSet = new Set([
    "first_name",
    "last_name",
    "address",
    "city",
    "postal_code",
    "country",
    "phone_code",
    "phone_number",
])

export default editMandatoryFieldsSet